<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-xd-12">
        <shopper-money-table :memberAmount="memberAmount"/>
      </div>
    </div>
  </section>
</template>

<script>
import shopperMoneyTableTemp from './Temp/ShopperMoneyTableTemp.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 99,
      tableIndex: 1,
      memberAmount: 0
    }
  },
  mounted () {
  },
  methods: {
  },
  components: {
    'shopper-money-table': shopperMoneyTableTemp
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// ShopperMoneyTable.vue?e5008f90